export const FULL_REQUEST = {
    locale: "cs",
    completedHtml: {
        cs: "⏳",
    },
    loadingHtml: {
        cs: "⏳",
    },
    pages: [
        {
            name: "page1",
            elements: [
                {
                    type: "text",
                    name: "person_code",
                    title: {
                        cs: "Rodné číslo",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    readOnly: true,
                    maskType: "pattern",
                    maskSettings: {
                        pattern: "999999/9999",
                    },
                },
                {
                    type: "text",
                    name: "first_name",
                    title: {
                        cs: "Jméno",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        default: "Required",
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatný formát hodnoty",
                            },
                            expression: "{first_name} empty or name_unicode({first_name})",
                        },
                        {
                            type: "text",
                            maxLength: 63,
                            text: {
                                cs: "Zadejte prosím méně než 63 znaků.",
                            },
                        },
                    ],
                },
                {
                    type: "text",
                    name: "last_name",
                    startWithNewLine: false,
                    title: {
                        cs: "Příjmení",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        default: "Required",
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatný formát hodnoty",
                            },
                            expression: "{last_name} empty or name_unicode({last_name})",
                        },
                        {
                            type: "text",
                            maxLength: 63,
                            text: {
                                cs: "Zadejte prosím méně než 63 znaků.",
                            },
                        },
                    ],
                },
                {
                    type: "text",
                    name: "email",
                    title: "Email",
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                        default: "Required",
                    },
                    validators: [
                        {
                            type: "email",
                            text: {
                                cs: "Zadejte prosím platnou e-mailovou adresu",
                            },
                        },
                        {
                            type: "text",
                            maxLength: 255,
                            text: {
                                cs: "Zadejte prosím méně než 255 znaků.",
                            },
                        },
                    ],
                    inputType: "email",
                    autocomplete: "email",
                    placeholder: "vas@email.cz",
                },
                {
                    type: "text",
                    name: "mobile_phone",
                    title: {
                        cs: "Telefonní číslo",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        default: "Required",
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "regex",
                            text: {
                                cs: "Neplatné telefonní číslo",
                            },
                            regex: "^(\\+420)?(71|72|73|77|601|602|603|604|605|606|607|608|702|703|704|705|706|707|708|709|721|722|723|724|725|726|727|728|729|790|792|797|799|2|31|32|35|37|38|39|41|47|46|48|49|51|53|54|55|56|57|58|59)",
                        },
                        {
                            type: "regex",
                            text: {
                                cs: "Neplatné telefonní číslo",
                            },
                            regex: "^(\\+420)?[\\d]{9}$",
                        },
                    ],
                    inputType: "tel",
                    maskType: "pattern",
                    maskSettings: {
                        pattern: "\\+\\4\\2\\0 999 999 999",
                    },
                },
                {
                    type: "boolean",
                    name: "remarketing_agree",
                    visible: false,
                },
            ],
        },
        {
            name: "address_info",
            title: {
                cs: "Adresa trvalého pobytu",
                default: "Contact information",
            },
            elements: [
                {
                    type: "text",
                    name: "city",
                    title: {
                        cs: "Město",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 63,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "street",
                    startWithNewLine: false,
                    title: {
                        cs: "Ulice",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 63,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "house_number",
                    title: {
                        cs: "Číslo popisné",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            minLength: 1,
                            maxLength: 10,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "zip",
                    startWithNewLine: false,
                    title: {
                        cs: "PSČ",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            minLength: 5,
                            maxLength: 5,
                        },
                        {
                            type: "expression",
                            text: {
                                cs: "Toto pole je povinné",
                            },
                            expression: "{zip} empty or digits_only({zip})",
                        },
                    ],
                    maskType: "pattern",
                    maskSettings: {
                        pattern: "99999",
                    },
                },
            ],
        },
        {
            name: "income",
            title: {
                cs: "Další informace",
            },
            elements: [
                {
                    type: "text",
                    name: "identity_card_number",
                    title: {
                        cs: "Číslo občanského průkazu",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            text: {
                                cs: "Neplatné číslo občanského průkazu",
                            },
                            minLength: 9,
                            maxLength: 9,
                        },
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné číslo občanského průkazu",
                            },
                            expression:
                                "{identity_card_number} empty or digits_only({identity_card_number})",
                        },
                    ],
                    maxLength: 9,
                },
                {
                    type: "dropdown",
                    name: "income_type",
                    title: {
                        cs: "Zdroj Vašich příjmů",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            expression:
                                "{income_type} empty or {income_type} anyof ['PART_TIME_EMPLOYMENT', 'UNEMPLOYED', 'WORKING_PENSIONER', 'PENSION_SELF_EMPLOYED', 'STUDENT', 'MATERNITY_LEAVE', 'PENSION', 'SELF_EMPLOYED', 'EMPLOYED']",
                        },
                    ],
                    choices: [
                        {
                            value: "EMPLOYED",
                            text: {
                                cs: "Zaměstnanec",
                            },
                        },
                        {
                            value: "SELF_EMPLOYED",
                            text: {
                                cs: "OSVČ",
                            },
                        },
                        {
                            value: "PENSION",
                            text: {
                                cs: "Důchodce",
                            },
                        },
                        {
                            value: "MATERNITY_LEAVE",
                            text: {
                                cs: "Mateřská / Rodičovská",
                            },
                        },
                        {
                            value: "STUDENT",
                            text: {
                                cs: "Student",
                            },
                        },
                        {
                            value: "PENSION_SELF_EMPLOYED",
                            text: {
                                cs: "Důchodce OSVČ",
                            },
                        },
                        {
                            value: "WORKING_PENSIONER",
                            text: {
                                cs: "Pracující důchodce",
                            },
                        },
                        {
                            value: "UNEMPLOYED",
                            text: {
                                cs: "Nezaměstnaný",
                            },
                        },
                        {
                            value: "PART_TIME_EMPLOYMENT",
                            text: {
                                cs: "Částečný úvazek",
                            },
                        },
                    ],
                },
                {
                    type: "slider",
                    name: "monthly_income",
                    title: {
                        cs: "Čistý měsíční příjem (v Kč)",
                    },
                    defaultValue: 0,
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            expression:
                                "{monthly_income} empty or ({monthly_income} <= 250000 and {monthly_income} >= 0)",
                        },
                    ],
                    max: 40000,
                    step: 1000,
                    customLabels: [
                        0,
                        {
                            value: 10000,
                            text: {
                                cs: "10 tis.",
                            },
                        },
                        {
                            value: 20000,
                            text: {
                                cs: "20 tis.",
                            },
                        },
                        {
                            value: 30000,
                            text: {
                                cs: "30 tis.",
                            },
                        },
                        {
                            value: 40000,
                            text: {
                                cs: "40+ tis.",
                            },
                        },
                    ],
                },
                {
                    type: "slider",
                    name: "expenses",
                    title: {
                        cs: "Přibližné měsíční výdaje (v Kč)",
                    },
                    defaultValue: 0,
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            expression:
                                "{expenses} empty or ({expenses} <= 250000 and {expenses} >= 0)",
                        },
                    ],
                    max: 40000,
                    step: 1000,
                    customLabels: [
                        {
                            value: 0,
                            text: {
                                cs: "0",
                            },
                        },
                        {
                            value: 10000,
                            text: {
                                cs: "10 tis.",
                            },
                        },
                        {
                            value: 20000,
                            text: {
                                cs: "20 tis.",
                            },
                        },
                        {
                            value: 30000,
                            text: {
                                cs: "30 tis.",
                            },
                        },
                        {
                            value: 40000,
                            text: {
                                cs: "40+ tis.",
                            },
                        },
                    ],
                },
            ],
        },
        {
            name: "Employment",
            visibleIf: "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
            elements: [
                {
                    type: "text",
                    name: "employer",
                    title: {
                        cs: "Zaměstnavatel",
                    },
                    requiredIf:
                        "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 127,
                        },
                    ],
                    autocomplete: "organization",
                    maxLength: 127,
                },
                {
                    type: "text",
                    name: "workplace_address",
                    title: {
                        cs: "Adresa zaměstnavatele ",
                    },
                    requiredIf:
                        "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 255,
                        },
                    ],
                    maxLength: 255,
                },
                {
                    type: "text",
                    name: "workplace_position",
                    title: {
                        cs: "Pracovní pozice ",
                    },
                    requiredIf:
                        "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 63,
                        },
                    ],
                    maxLength: 63,
                },
                {
                    type: "text",
                    name: "year_month_of_working",
                    title: {
                        cs: "Pracuji zde od",
                    },
                    requiredIf:
                        "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Toto pole je povinné",
                            },
                            expression:
                                "{year_month_of_working} empty or year_month_interval({year_month_of_working}, '1965-01', today())",
                        },
                    ],
                    inputType: "month",
                    min: "1965-01",
                },
            ],
        },
        {
            name: "self_employed",
            visibleIf: "{income_type} = 'SELF_EMPLOYED' or {income_type} = 'PENSION_SELF_EMPLOYED'",
            elements: [
                {
                    type: "text",
                    name: "company_number",
                    title: {
                        cs: "IČO",
                    },
                    requiredIf:
                        "{income_type} = 'SELF_EMPLOYED' or {income_type} = 'PENSION_SELF_EMPLOYED'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            text: {
                                cs: "Neplatné IČO",
                            },
                            minLength: 8,
                            maxLength: 8,
                        },
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné IČO",
                            },
                            expression: "{company_number} empty or digits_only({company_number})",
                        },
                    ],
                    maskType: "pattern",
                    maskSettings: {
                        pattern: "99999999",
                    },
                },
            ],
        },
        {
            name: "Smoker",
            visibleIf: "{remarketing_agree} = true",
            elements: [
                {
                    type: "boolean",
                    name: "is_smoker",
                    title: {
                        cs: "Jste kuřák?",
                    },
                    labelTrue: {
                        cs: "Ano",
                    },
                    labelFalse: {
                        cs: "Ne",
                    },
                },
            ],
        },
        {
            name: "financial_info",
            title: {
                cs: "Kam chcete obdržet peníze?",
            },
            elements: [
                {
                    type: "text",
                    name: "bank_account_prefix",
                    title: {
                        cs: "Předčíslí",
                    },
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            text: {
                                cs: "Neplatné předčíslí",
                            },
                            maxLength: 6,
                        },
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné předčíslí",
                            },
                            expression:
                                "{bank_account_prefix} empty or cz_bank_prefix({bank_account_prefix})",
                        },
                    ],
                    maxLength: 6,
                },
                {
                    type: "text",
                    name: "account_number",
                    startWithNewLine: false,
                    title: {
                        cs: "Číslo účtu",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné číslo účtu",
                            },
                            expression:
                                "{account_number} empty or cz_bank_account({account_number})",
                        },
                        {
                            type: "text",
                            text: {
                                cs: "Neplatné číslo účtu",
                            },
                            minLength: 2,
                            maxLength: 10,
                        },
                    ],
                    maxLength: 10,
                },
                {
                    type: "dropdown",
                    name: "bank_code",
                    title: {
                        cs: "Kód banky",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatný kód banky",
                            },
                            expression:
                                "{bank_code} empty or {bank_code} anyof ['0100', '0300', '0400', '0600', '0710', '0800', 1600, 1900, 2010, 2020, 2030, 2050, 2060, 2070, 2100, 2200, 2210, 2220, 2230, 2240, 2250, 2310, 2400, 2500, 2600, 2700, 2800, 2865, 3030, 3050, 3300, 3400, 3500, 3800, 3900, 4000, 4300, 4400, 4500, 4600, 5000, 5100, 5400, 5500, 5700, 5800, 6000, 6100, 6200, 6210, 6300, 6400, 6700, 6800, 7910, 7920, 7940, 7950, 7960, 7970, 7980, 7990, 8030, 8040, 8046, 8060, 8070, 8090, 8150, 8200]",
                        },
                    ],
                    choices: [
                        {
                            value: "0100",
                            text: {
                                cs: "0100-Komerční banka a. s. ",
                            },
                        },
                        {
                            value: "0300",
                            text: {
                                cs: "0300-Československá obchodní banka a. s.",
                            },
                        },
                        {
                            value: "0400",
                            text: {
                                cs: "0400-Živnostenská banka a. s. ",
                            },
                        },
                        {
                            value: "0600",
                            text: {
                                cs: "0600-GE Money Bank a. s. ",
                            },
                        },
                        {
                            value: "0710",
                            text: {
                                cs: "0710-Česká národní banka ",
                            },
                        },
                        {
                            value: "0800",
                            text: {
                                cs: "0800-Česká spořitelna a. s. ",
                            },
                        },
                        {
                            value: "1600",
                            text: {
                                cs: "1600-Pragobanka a. s. ",
                            },
                        },
                        {
                            value: "1900",
                            text: {
                                cs: "1900-SOCIETE GENERALE BANKA a. s. ",
                            },
                        },
                        {
                            value: "2010",
                            text: {
                                cs: "2010-Fio banka a. s. ",
                            },
                        },
                        {
                            value: "2020",
                            text: {
                                cs: "2020-Bank of Tokyo-Mitsubishi UFJ (Holland)N.V. Prague Branch, organizační složka ",
                            },
                        },
                        {
                            value: "2030",
                            text: {
                                cs: "2030-AKCENTA, spořitelní a úvěrní družstvo",
                            },
                        },
                        {
                            value: "2050",
                            text: {
                                cs: "2050-WPB Capital, spořitelní družstvo",
                            },
                        },
                        {
                            value: "2060",
                            text: {
                                cs: "2060-Citfin, spořitelní družstvo ",
                            },
                        },
                        {
                            value: "2070",
                            text: {
                                cs: "2070-Moravský Peněžní Ústav – spořitelnídružstvo ",
                            },
                        },
                        {
                            value: "2100",
                            text: {
                                cs: "2100-Hypoteční banka a. s. ",
                            },
                        },
                        {
                            value: "2200",
                            text: {
                                cs: "2200-Peněžní dům, spořitelní družstvo",
                            },
                        },
                        {
                            value: "2210",
                            text: {
                                cs: "2210-Evropsko-ruská banka a. s. ",
                            },
                        },
                        {
                            value: "2220",
                            text: {
                                cs: "2220-Artesa, spořitelní družstvo ",
                            },
                        },
                        {
                            value: "2230",
                            text: {
                                cs: "2230-AXA Bank Europe, organizační složka",
                            },
                        },
                        {
                            value: "2240",
                            text: {
                                cs: "2240-Poštová banka a. s., pobočka Českárepublika ",
                            },
                        },
                        {
                            value: "2250",
                            text: {
                                cs: "2250-Záložna CREDITAS, spořitelní družstvo",
                            },
                        },
                        {
                            value: "2310",
                            text: {
                                cs: "2310-ZUNO BANK AG ",
                            },
                        },
                        {
                            value: "2400",
                            text: {
                                cs: "2400-eBanka a. s. ",
                            },
                        },
                        {
                            value: "2500",
                            text: {
                                cs: "2500-Interbanka a. s. ",
                            },
                        },
                        {
                            value: "2600",
                            text: {
                                cs: "2600-Citibank Europe plc, organizačnísložka ",
                            },
                        },
                        {
                            value: "2700",
                            text: {
                                cs: "2700-UniCredit Bank Czech Republic a. s.",
                            },
                        },
                        {
                            value: "2800",
                            text: {
                                cs: "2800-Bank Austria (ČR) a. s. ",
                            },
                        },
                        {
                            value: "2865",
                            text: {
                                cs: "2865-Preciosa - podniková banka ",
                            },
                        },
                        {
                            value: "3030",
                            text: {
                                cs: "3030-Air Bank a. s. ",
                            },
                        },
                        {
                            value: "3050",
                            text: {
                                cs: "3050-Hello Bank ",
                            },
                        },
                        {
                            value: "3300",
                            text: {
                                cs: "3300-Konsolidační banka Praha s. p. ú.",
                            },
                        },
                        {
                            value: "3400",
                            text: {
                                cs: "3400-UNION Banka a. s. ",
                            },
                        },
                        {
                            value: "3500",
                            text: {
                                cs: "3500-ING Bank N.V. ",
                            },
                        },
                        {
                            value: "3800",
                            text: {
                                cs: "3800-Vereinsbank (CZ) a. s. ",
                            },
                        },
                        {
                            value: "3900",
                            text: {
                                cs: "3900-HYPO-BANK CZ a. s. ",
                            },
                        },
                        {
                            value: "4000",
                            text: {
                                cs: "4000-LBBW Bank CZ a. s. ",
                            },
                        },
                        {
                            value: "4300",
                            text: {
                                cs: "4300-Českomoravská záruční a rozvojovábanka a. s. ",
                            },
                        },
                        {
                            value: "4400",
                            text: {
                                cs: "4400-Erste Bank Sparkassen (ČR) ",
                            },
                        },
                        {
                            value: "4500",
                            text: {
                                cs: "4500-Moravia banka a. s. ",
                            },
                        },
                        {
                            value: "4600",
                            text: {
                                cs: "4600-Plzeňská banka a. s. ",
                            },
                        },
                        {
                            value: "5000",
                            text: {
                                cs: "5000-Credit Lyonnais Bank Praha a. s.",
                            },
                        },
                        {
                            value: "5100",
                            text: {
                                cs: "5100-Investiční a poštovní banka a. s.",
                            },
                        },
                        {
                            value: "5400",
                            text: {
                                cs: "5400-The Royal Bank of Scotland plc,organizační složka ",
                            },
                        },
                        {
                            value: "5500",
                            text: {
                                cs: "5500-Raiffeisenbank a. s. ",
                            },
                        },
                        {
                            value: "5700",
                            text: {
                                cs: "5700-Velkomoravská banka a. s. ",
                            },
                        },
                        {
                            value: "5800",
                            text: {
                                cs: "5800-J &amp; T Banka a. s. ",
                            },
                        },
                        {
                            value: "6000",
                            text: {
                                cs: "6000-PPF banka a. s. ",
                            },
                        },
                        {
                            value: "6100",
                            text: {
                                cs: "6100-Equa bank a. s. ",
                            },
                        },
                        {
                            value: "6200",
                            text: {
                                cs: "6200-Commerzbank AG ",
                            },
                        },
                        {
                            value: "6210",
                            text: {
                                cs: "6210-mBank S.A., organizační složka podniku",
                            },
                        },
                        {
                            value: "6300",
                            text: {
                                cs: "6300-BNP Paribas Fortis SA/NV, pobočkaČeská republika ",
                            },
                        },
                        {
                            value: "6400",
                            text: {
                                cs: "6400-Universal banka a. s. ",
                            },
                        },
                        {
                            value: "6700",
                            text: {
                                cs: "6700-Všeobecná úverová banka a. s., pobočkaPraha ",
                            },
                        },
                        {
                            value: "6800",
                            text: {
                                cs: "6800-Sberbank CZ a. s. ",
                            },
                        },
                        {
                            value: "7910",
                            text: {
                                cs: "7910-Deutsche Bank A.G. Filiale Prag",
                            },
                        },
                        {
                            value: "7920",
                            text: {
                                cs: "7920-Foresbank a. s. ",
                            },
                        },
                        {
                            value: "7940",
                            text: {
                                cs: "7940-Waldviertler Sparkasse Bank AG",
                            },
                        },
                        {
                            value: "7950",
                            text: {
                                cs: "7950-Raiffeisen stavební spořitelna a. s.",
                            },
                        },
                        {
                            value: "7960",
                            text: {
                                cs: "7960-Českomoravská stavební spořitelna a.s. ",
                            },
                        },
                        {
                            value: "7970",
                            text: {
                                cs: "7970-Wüstenrot-stavební spořitelna a. s.",
                            },
                        },
                        {
                            value: "7980",
                            text: {
                                cs: "7980-Wüstenrot hypoteční banka a. s.",
                            },
                        },
                        {
                            value: "7990",
                            text: {
                                cs: "7990-Modrá pyramida stavební spořitelna a.s. ",
                            },
                        },
                        {
                            value: "8030",
                            text: {
                                cs: "8030-Raiffeisenbank im Stiftland eG pobočkaCheb, odštěpný závod ",
                            },
                        },
                        {
                            value: "8040",
                            text: {
                                cs: "8040-Oberbank AG pobočka Česká republika",
                            },
                        },
                        {
                            value: "8046",
                            text: {
                                cs: "8046-SMW Banka ",
                            },
                        },
                        {
                            value: "8060",
                            text: {
                                cs: "8060-Stavební spořitelna České spořitelnya. s. ",
                            },
                        },
                        {
                            value: "8070",
                            text: {
                                cs: "8070-HYPO - stavební spořitelna a. s.",
                            },
                        },
                        {
                            value: "8090",
                            text: {
                                cs: "8090-Česká exportní banka a. s. ",
                            },
                        },
                        {
                            value: "8150",
                            text: {
                                cs: "8150-HSBC Bank plc - pobočka Praha",
                            },
                        },
                        {
                            value: "8200",
                            text: {
                                cs: "8200-PRIVAT BANK AG derRaiffeisenlandesbank Oberösterreich v České republice ",
                            },
                        },
                    ],
                },
            ],
        },
    ],
    showTitle: false,
    questionErrorLocation: "bottom",
    checkErrorsMode: "onValueChanged",
    textUpdateMode: "onTyping",
    pagePrevText: {
        default: "Previous",
        cs: "Předchozí",
    },
    pageNextText: {
        default: "Proceed",
        cs: "Pokračovat",
    },
    completeText: {
        default: "GET MONEY",
        cs: "ZÍSKAT PENÍZE",
    },
    questionsOnPageMode: "singlePage",
    headerView: "advanced",
};
